// extracted by mini-css-extract-plugin
export default {"container":"IconWithText-module__container__TRd5R","icon":"IconWithText-module__icon__dOVtI","text":"IconWithText-module__text__gyYCp"};